import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "@/components/ui/tooltip";
import { formattedNumber } from "@/utilities/formatNumbers";
import { Typography } from "@mui/material";
import { ColumnDef } from "@tanstack/react-table";

export type LiquidationsColumns = {
  concepto: string;
  total: string;
  moneda: string;
};

const currency = {
  1: "Pesos",
  2: "Dolares",
};

export const columnsLiquidations: ColumnDef<LiquidationsColumns>[] = [
  {
    accessorKey: "concepto",
    header: () => (
      <div className="text-left max-w-[100px] min-w-[100px]">
        <Typography fontFamily={"Inter"} fontSize={"14px"} fontWeight={500}>
          Concepto
        </Typography>
      </div>
    ),
    cell: ({ row }) => {
      return (
        <Tooltip>
          <TooltipTrigger>
            <div
              className="text-left font-medium max-w-[100px] min-w-[100px] truncate"
              aria-label="concepto-liquidacion"
            >
              <Typography
                fontFamily={"Inter"}
                fontSize={"14px"}
                fontWeight={400}
                className="truncate"
              >
                {row.original.concepto}
              </Typography>
            </div>
          </TooltipTrigger>
          <TooltipContent>
            <Typography fontFamily={"Inter"} fontSize={"14px"} fontWeight={400}>
              {row.original.concepto}
            </Typography>
          </TooltipContent>
        </Tooltip>
      );
    },
  },
  {
    accessorKey: "total",
    header: () => (
      <div className="text-left">
        <Typography fontFamily={"Inter"} fontSize={"14px"} fontWeight={500}>
          Total
        </Typography>
      </div>
    ),
    cell: ({ row }) => {
      return (
        <div
          className="text-left font-medium max-w-[150px] min-w-[150px] truncate"
          aria-label="total-liquidacion"
        >
          <Typography fontFamily={"Inter"} fontSize={"14px"} fontWeight={400}>
            {`${formattedNumber(row.original.total)} ${
              currency[Number(row.original.moneda) as keyof typeof currency]
            }`}
          </Typography>
        </div>
      );
    },
  },
];
